module.exports = __webpack_public_path__ + "img/diana.e339149f.jpg";